'use client';

import DailyBonus from '@/components/entities/dailyBonus';
import { GmBundleOffers } from '@/components/features/gamification/shop/GmBundleOffers';
import { cn } from '@/utils/cn';
import { useUnclaimedGamificationRewardsCount } from '../../modules/rewards/hooks/useUnclaimedGamificationRewardsCount';
import { GamificationRewardsGrid } from './GamificationRewardsGrid';

interface GamificationRewardsContentProps {
  className?: string;
  withBundleOffers?: boolean;
}

export const GamificationRewardsContent = ({ className, withBundleOffers }: GamificationRewardsContentProps) => {
  const { countORewardsWithoutDailyAndReferral } = useUnclaimedGamificationRewardsCount();

  return (
    <div className={cn('flex flex-col gap-5 md:gap-6', className)}>
      <DailyBonus appearance="rewards-page" />
      {withBundleOffers && <GmBundleOffers />}
      <GamificationRewardsGrid countOfGamificationRewards={countORewardsWithoutDailyAndReferral} />

    </div>
  );
};
